import { i18n } from '@/app/I18n'
import { languageItem } from '@/language/helpers'
import ExtendCartTimerModal from '@/modals/ExtendCartTimerModal.vue'
import { ModalCloseHandlerFn } from '@/modals/helpers/types'
import { openModal } from '@/modals/helpers/api'
import CartExpiryModal from '@/modals/CartExpiryModal.vue'

export function openCartExpiryModal(onClose?: ModalCloseHandlerFn) {
  const language = languageItem('cartExpire')
  openModal({
    name: 'cart-expiry-modal',
    title: language.title,
    closeable: false,
    size: 'sm',
    component: CartExpiryModal,
    onClose,
    describedBy: 'cart-expiry-content',
  })
}

export function openExtendCartTimerModal() {
  const language = languageItem('extendCartTimerModal')
  openModal({
    name: 'extend-cart-timer-modal',
    title: language.title,
    closeable: false,
    size: 'md',
    component: ExtendCartTimerModal,
    describedBy: 'extend-cart-timer-content',
  })
}
